import {
  getNotesTableNoteStatusColumn,
  getNotesTableNoteTitleColumn,
  getNotesTableDierctionColumn,
  getNotesTableDueDateColumn,
  getNotesTableNoteDateColumn,
  getNotesTableNoteTypeColumn,
  getNotesTableImportantColumn,
  getNotesTablePersonColumn,
  getNotesTablePersonTitleColumn,
} from "../../model/notes-table-columns-getters";

export const useNotesTableColumns = () => {
  const notesTableColumnsGetters = {
    getNotesTableNoteStatusColumn,
    getNotesTableNoteTitleColumn,
    getNotesTableDierctionColumn,
    getNotesTableDueDateColumn,
    getNotesTableNoteDateColumn,
    getNotesTableNoteTypeColumn,
    getNotesTablePersonColumn,
    getNotesTablePersonTitleColumn,
    getNotesTableImportantColumn,
  };

  return { notesTableColumnsGetters };
};
